import React, { useEffect, useRef } from "react";
import "./Popup.css";
import { PopupAction } from "../../../core/types/PopupAction";

interface PopupProps {
  children?: React.ReactNode;
  additionalClass?: string;
  closeAction: PopupAction;
  actions?: PopupAction[];
}

export const Popup: React.FC<PopupProps> = ({ children, additionalClass, closeAction, actions }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (dialogRef.current && !dialogRef.current.open) {
      dialogRef.current.showModal();
    }
  }, [children]);

  return (
    <dialog
      ref={dialogRef}
      className={`${additionalClass ?? ''} animate-popup popup`}
      onClick={(e) => {
        if (e.target === dialogRef.current) {
          closeAction.callback();
        }
      }}
    >
      {children}

      <div className="popup-actions">
        {[...actions ?? [], closeAction].map((action, idx) => (
          <button
            key={idx}
            className={`btn ${action.className ?? "btn-secondary"}`}
            onClick={action.callback}
          >
            {action.label}
          </button>
        ))}
      </div>

    </dialog>
  );
};
